import { Button } from '@/components/ui/button'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { queryClient } from '@/integrations/react-query'
import { getAuth, signOut } from 'firebase/auth'
import { LogOut } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

export const AppHeader = () => {
  const navigate = useNavigate()

  const handleLogout = async () => {
    const auth = getAuth()
    signOut(auth)
      .then(() => {
        toast.success('Utloggad')
        navigate('/auth')
        queryClient.clear()
        // Sign-out successful.
      })
      .catch(error => {
        // An error happened.
        console.error('Firebase logout error', error)
        toast.error('Kunde inte logga ut')
      })
  }

  return (
    <header className="h-16 border-b border-border bg-background flex items-center px-6 justify-between">
      <SidebarTrigger />
      <Button variant="ghost" size="sm" onClick={handleLogout}>
        <LogOut className="h-4 w-4 mr-2" />
        Logga ut
      </Button>
    </header>
  )
}
